import { render, staticRenderFns } from "./ConfirmPayment.vue?vue&type=template&id=0033a832&"
import script from "./ConfirmPayment.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConfirmPayment.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports